'use client';

import { useTranslations } from 'next-intl';
import type { VariantProps } from 'tailwind-variants';

import { UiKitButton } from '@/ui-kit/button';
import { toastBase } from '@/ui-kit/toast';

import { styles } from './UiKitTextCopy.styles';

type Variants = VariantProps<typeof styles>;

export type BackgroundColor = Variants['bgColor'];

export interface UiKitTextCopyProps {
  className?: string;
  text: string;
  bgColor?: BackgroundColor;
  textClassName?: string;
  buttonClassName?: string;
}

export function UiKitTextCopy({
  className,
  text,
  bgColor = 'base',
  textClassName,
  buttonClassName
}: UiKitTextCopyProps) {
  const slots = styles({ bgColor });
  const t = useTranslations();

  const onCopyText = () => {
    navigator.clipboard.writeText(text).then(() => {
      toastBase(t('Copied'));
    });
  };

  return (
    <div className={slots.base({ className })}>
      <div className={slots.text({ className: textClassName })}>{text}</div>
      <UiKitButton
        color="primary"
        onClick={onCopyText}
        className={slots.button({ className: buttonClassName })}
      >
        {t('Copy')}
      </UiKitButton>
    </div>
  );
}
